
import React from 'react'
import { Link } from 'gatsby'

import style from './Type.module.scss'

const Type = ({ 
  param,
  microcopy
}) => (
  <span className= { style.types }>
    <>{ param.resource ? <Link to={param.resource.path}>{param.resource.title}</Link> : param.itemType } </>
    { param.resources?.map((resource, index) => (
      <>{ index > 0 && '/ ' }<Link key={resource.id} to={resource.path}>{resource.title}</Link> </>
    )) }
    { param.hasAdditionalProperties && !param.resource ? microcopy.text('reference.parameter_types.associative_array') : param.type }
    { param.format && param.format !== param.type && ` / ${param.format}`}
  </span>
)

export default Type